<template>
  <div>
    <ad-shop-query :buyer-id="buyerId">
      <template slot-scope="{ isLoading, data: adShop }">
        <div v-if="adShop" class="result">
          <transition name="fade" mode="out-in">
            <sign-in-flow
              v-if="activeFlow === FLOW_SIGN_IN"
              @signUpRequest="activeFlow = FLOW_CREATE_ACCOUNT"
              @signedIn="$emit('signedIn')"
            />
            <create-account-flow
              v-else-if="activeFlow === FLOW_CREATE_ACCOUNT"
              :supplier-id="adShop.supplier.id"
              @signInRequest="activeFlow = FLOW_SIGN_IN"
              @signedIn="$emit('signedIn')"
            />
            <div v-else class="text-center">
              <div
                v-if="adShop.profilePhotoFile"
                class="result adshop-profile-photo"
              >
                <img
                  alt="Profile Photo"
                  class="profile-photo"
                  :src="adShop.profilePhotoFile.url"
                />
              </div>
              <p class="connect-info">
                In order to finish booking, you'll need to create an account
                with our partner site flytedesk. This will allow you to track
                the progress of your ads, upload artwork, and view
                verifications.
              </p>
              <div class="flex items-center justify-center">
                <el-button
                  class="button-white-blue mr-5 w-1/4"
                  @click="activeFlow = FLOW_SIGN_IN"
                >
                  I already have an account
                </el-button>
                <el-button
                  class="button-white-blue mr-5 w-1/4"
                  @click="activeFlow = FLOW_CREATE_ACCOUNT"
                >
                  Create Account
                </el-button>
              </div>
              <p class="flytedesk-power">
                Powered by
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 1150.8 311.1"
                  class="h-full w-40"
                >
                  <path
                    fill="#052e4a"
                    d="M212.8,132.8c4.8,0,7.6.7,9.1,1.1v-24.4c-2.4-1.1-8.3-2.2-14.4-2.2-23.7,0-38.9,15.7-38.9,39.8v12.2h-17.8v24.8h17.8v82.2h29.1v-82.2h24.1v-24.8h-24.1v-11.7c0-12,8.5-14.8,15-14.8Z"
                  />
                  <path
                    fill="#052e4a"
                    d="M264.6,266.3V108.9h-28.9v157.5h28.9Z"
                  />
                  <path
                    fill="#052e4a"
                    d="M434,127.3h-26.1v15c0,9.6-5.2,17-16.5,17h-5.4v25.7h19.4v49.8c0,20.7,13.1,33.1,33.9,33.1s13.7-1.5,16.3-2.6v-23.9c-1.5.4-5.4.9-8.9.9-8.3,0-12.6-3-12.6-12.4v-44.8h21.5v-25.7h-21.5v-32Z"
                  />
                  <path
                    fill="#052e4a"
                    d="M490.3,200.6c.7-9.8,8.9-21.1,23.9-21.1s23.5,10.4,23.9,21.1h-47.9ZM540.9,228.5c-3.5,9.6-10.9,16.3-24.4,16.3s-26.3-10.2-27-24.4h76.6c0-.4.4-4.8.4-8.9,0-34.4-19.8-55.5-52.9-55.5s-52.6,22.2-52.6,56.3,25.9,57.2,55.2,57.2,43.3-15.4,48.7-33.9l-24.1-7.2Z"
                  />
                  <path
                    fill="#052e4a"
                    d="M723.2,200.6c.7-9.8,8.9-21.1,23.9-21.1s23.5,10.4,23.9,21.1h-47.9ZM773.9,228.5c-3.5,9.6-10.9,16.3-24.4,16.3s-26.3-10.2-27-24.4h76.6c0-.4.4-4.8.4-8.9,0-34.4-19.8-55.5-52.9-55.5s-52.6,22.2-52.6,56.3,25.9,57.2,55.2,57.2,43.3-15.4,48.7-33.9l-24.1-7.2Z"
                  />
                  <path
                    fill="#052e4a"
                    d="M802.5,236.5c1.3,12.2,12.4,33.1,44.6,33.1s41.5-17.8,41.5-35.2-10.7-28.5-31.8-32.8l-15.2-3.3c-5.9-1.1-9.8-4.4-9.8-9.6s6.1-10.7,13.7-10.7c12.2,0,16.7,8,17.6,14.4l24.1-5.4c-1.3-11.5-11.5-30.9-42-30.9s-40,15.9-40,35,9.4,27.4,30,32l14.1,3.3c8.3,1.7,11.5,5.7,11.5,10.4s-4.6,10.7-14.1,10.7-18.9-7.8-19.6-16.3l-24.8,5.4Z"
                  />
                  <path
                    fill="#052e4a"
                    d="M998.5,159.3h-37.8l-37,39.8v-90.3h-28.9v157.5h28.9v-28.3l12-12.6,28.3,40.9h35.5l-43.7-62,42.8-45Z"
                  />
                  <path
                    fill="#052e4a"
                    d="M687.9,108.9h-28.5v61.1c-3-5.7-11.7-13.3-30.2-13.3-30.2,0-51.3,24.6-51.3,55.9s21.8,56.3,52.2,56.3,25.2-6.5,30-15c0,5,.7,10.2,1.1,12.4h27.6c-.4-4.3-.9-12.2-.9-19.4V108.9ZM606.9,212.6c0-19.1,11.7-30,26.5-30s26.3,10.7,26.3,29.8-11.5,30.7-26.3,30.7-26.5-11.3-26.5-30.5Z"
                  />
                  <path
                    fill="#052e4a"
                    d="M352.3,159h30l-39.5,108.6c-5.6,15.6-13.2,26.9-22.6,33.9-9.3,7.1-20.8,10.3-34.7,9.6v-26c7.5.1,13.5-1.4,17.8-4.8,4.5-3.3,8-8.7,10.6-16.1l-44.5-105.1h30.6l28.2,72.9,24.1-72.9Z"
                  />
                  <path
                    fill="#80bfe9"
                    d="M1046.3,121.7L1150.8,1.5s-41,160.2-48.5,168.8c-7.3,8.4-44.1,5.8-49.8.8-5.7-5-6.1-49.5-6.1-49.5Z"
                  />
                  <path
                    fill="#2272ba"
                    d="M1031.8,108.6L1148.3,0s-158.6,46.6-167,54.4c-8.1,7.6-4.2,44.3.9,49.8,5.2,5.5,49.6,4.4,49.6,4.4Z"
                  />
                </svg>
              </p>
            </div>
          </transition>
        </div>
        <loading-page v-else :failed="!isLoading">
          <template slot="failed-text">Ad Shop Settings not found</template>
        </loading-page>
      </template>
    </ad-shop-query>
  </div>
</template>

<script>
import CreateAccountFlow from '@/components/AdShop/Cart/CreateAccountFlow';
import SignInFlow from '@/components/AdShop/Cart/SignInFlow';
import LoadingPage from '@/components/Core/Loading/LoadingPage';
import { AdShopQuery } from '@/components/Queries';

const FLOW_SIGN_IN = 'SIGN_IN';
const FLOW_CREATE_ACCOUNT = 'CREATE_ACCOUNT';

export default {
  name: 'ConnectAccount',

  components: {
    AdShopQuery,
    CreateAccountFlow,
    LoadingPage,
    SignInFlow
  },

  data() {
    return {
      FLOW_SIGN_IN,
      FLOW_CREATE_ACCOUNT,

      activeFlow: null
    };
  },

  computed: {
    buyerId() {
      return this.$store.getters['auth/buyerId'];
    }
  }
};
</script>

<style scoped lang="scss">
@import '~@/scss/_variables';

.connect-info {
  margin: 1em;
}

.flytedesk-power {
  font-size: 1em;
  margin-top: 1em;
}

.profile-photo {
  max-width: 6em;
}
</style>
